<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="电话拨号" :width="1000" :open="true" :maskClosable="true" @ok="cancel" @cancel="cancel" :footer="null">
        <a-spin :spinning="state.loading">
            <a-row :gutter="48" style="margin: 10px 0;">
                <a-col :span="6">连接状态</a-col>
                <a-col :span="6">摘挂机状</a-col>
                <a-col :span="6">录音状态</a-col>
            </a-row>
            <a-row :gutter="48" style="margin: 10px 0;">
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.wsClient && $store.state.usbphone.icm_flag == 1"
                        color="green">已连接</a-tag>
                    <a-tag v-else color="red">未连接</a-tag>
                </a-col>
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.p_status == 0" color="red">挂机</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 1" color="green" :icon="h(SoundOutlined)">摘机</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 2" color="blue">HOLD</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 3" color="green"
                        :icon="h(SoundOutlined)">耳机摘机</a-tag>
                </a-col>
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.r_status == 0" color="red">停止录音</a-tag>
                    <a-tag v-if="$store.state.usbphone.r_status == 1" color="green"
                        :icon="h(CloudUploadOutlined)">正在录音</a-tag>
                </a-col>
            </a-row>
            <a-card>
                <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                    <a-form-item label="公司名称">
                        {{ formState.full_name }}
                    </a-form-item>
                    <a-form-item label="电话号码">
                        {{ formState.phone }}
                        <a-popconfirm v-if="$store.state.usbphone.p_status == 0" :title="`确定立即拨号?`"
                            @confirm="makePhoneCall">
                            <a-button type="primary" :loading="state.callLoading" size="small"
                                :icon="h(PhoneOutlined)">立即拨号</a-button>
                        </a-popconfirm>
                        <a-button type="primary" danger @click="makePhoneCallEnd" :loading="state.callLoading"
                            size="small" v-else>挂断</a-button>
                        <a-divider type="vertical" /> <a-button type="primary" danger size="small"
                            :icon="h(MessageOutlined)" @click="sendmsg" :loading="state.msgPreLoading">发送短信</a-button>

                        <a-divider type="vertical" /><a>日志</a>
                    </a-form-item>
                    <a-divider>额外信息（选填）</a-divider>
                    <a-form-item label="操作原因" name="reason">
                        <a-textarea placeholder="请输入" v-model:value="formState.reason"
                            @change="storeBeizhu"></a-textarea>
                    </a-form-item>
                    <a-form-item label="本次操作总结" name="remark">
                        <a-textarea placeholder="请输入" v-model:value="formState.remark"
                            @change="storeBeizhu"></a-textarea>
                    </a-form-item>
                    <div v-if="state.showMsg">
                        <a-form-item label="短信模板" name="templet"
                            title="默认标签：{#tel#}短信收到的号码，{#compayname#}公司名称，{#name#}法人代表姓名">
                            <a-textarea placeholder="默认标签：{#tel#}短信收到的号码，{#compayname#}公司名称，{#name#}法人代表姓名"
                                v-model:value="formState.templet" @change="updateMsg"></a-textarea>
                            <p v-if="state.showTemplet">
                                <a-row v-for="(value, index) in state.templets" :key="index">
                                    <a-col :span="2">{{ index + 1 }}</a-col>
                                    <a-col :span="22">
                                        <a @click="changeTemplet">{{ value }}</a>
                                    </a-col>
                                </a-row>
                            </p>
                            <a @click="showOrHideTemplet">获取短信模板</a>
                        </a-form-item>
                        <a-form-item label="短信内容" name="msg">
                            <p>{{ formState.msg }}</p>
                            <a-button type="primary" danger size="small" :icon="h(MessageOutlined)" @click="makeSendMsg"
                                :loading="state.msgLoading">立即发送短信</a-button>
                        </a-form-item>
                    </div>
                    <a-form-item label="操作">
                        <a-button type="primary" @click="submitForm" :loading="state.saveLoading"
                            :icon="h(SaveOutlined)">保存理由及总结</a-button>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, h, watch } from 'vue'
import { PhoneOutlined, SaveOutlined, SoundOutlined, CloudUploadOutlined, MessageOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { useStore } from 'vuex'
const $store = useStore()
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    loading: boolean
    callLoading: boolean
    saveLoading: boolean
    showMsg: boolean
    msgPreLoading: boolean
    showTemplet: boolean
    thdata: any[],
    templets: any[],
    msgLoading: boolean

}
const state = reactive<state>({
    loading: false,
    callLoading: false,
    saveLoading: false,
    showMsg: false,
    msgPreLoading: false,
    showTemplet: false,
    thdata: [],
    templets: [],
    msgLoading: false
})
interface formState {
    phone: string
    customer_id: number
    full_name: string
    zipid: number | null
    reason: string
    remark: string
    templet: string
    msg: string
}
let formState = reactive<formState>({
    phone: '',
    customer_id: 0,
    full_name: '',
    zipid: null,
    reason: '',
    remark: '',
    templet: '',
    msg: ''
})
onMounted(() => {
    // 关键：打开弹窗先关闭其他标签残留的WebSocket，释放通道
    const oldWs = $store.state.usbphone.wsClient
    if (oldWs && oldWs.readyState === WebSocket.OPEN) {
        oldWs.close(1000, "其他弹窗抢占连接");
        $store.commit("usbphone/SET_WSCLIENT", null);
    }
    // 重新建立当前弹窗的连接
    $store.dispatch('usbphone/Connect')

    let modalCurentInfo = $store.state.usbphone.modalCurentInfo
    formState.customer_id = modalCurentInfo.customer_id
    formState.full_name = modalCurentInfo.full_name
    formState.phone = modalCurentInfo.phone
    formState.zipid = modalCurentInfo.zipid
    formState.reason = modalCurentInfo.reason
    formState.remark = modalCurentInfo.remark
})

// 监听挂机自动清空通话数据
watch(() => $store.state.usbphone.p_status, (newVal) => {
    if (newVal === 0) {
        formState.zipid = null
        state.showMsg = false
    }
})

const cancel = () => {
    // 直接关闭弹窗，强制断开WS，释放通道给其他标签
    const ws = $store.state.usbphone.wsClient
    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.close();
        $store.commit("usbphone/SET_WSCLIENT", null);
    }
    $store.dispatch('usbphone/HidePhoneModal')
}
const onConnectClick = () => {
    $store.dispatch('usbphone/Connect', '')
}
const makePhoneCall = () => {
    state.showMsg = false
    if (!formState.phone || formState.phone.length != 11) {
        message.error('未找到正确的手机号')
        return
    }
    state.callLoading = true
    let requestParam = {
        url: '/admin/v1/usbphoneCall',
        method: 'post',
        data: {
            'step': 1,
            'customer_id': formState.customer_id,
            'phone': formState.phone
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            formState.zipid = res.data
            let modalCurentInfo = $store.state.usbphone.modalCurentInfo
            modalCurentInfo.zipid = res.data
            $store.commit('usbphone/SET_MODALCURENTINFO', modalCurentInfo)
            $store.dispatch('usbphone/PhoneCall', { 'phone': formState.phone, 'zipid': res.data })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.callLoading = false
        })
}
const makePhoneCallEnd = () => {
    $store.dispatch('usbphone/PhoneCallEnd')
}
const storeBeizhu = () => {
    let modalCurentInfo = $store.state.usbphone.modalCurentInfo
    modalCurentInfo.reason = formState.reason
    modalCurentInfo.remark = formState.remark
    $store.commit('usbphone/SET_MODALCURENTINFO', modalCurentInfo)
}
const submitForm = () => {
    if (!formState.customer_id) {
        return
    }
    if (!formState.zipid) {
        message.error('请先拨号')
        return
    }
    if (formState.remark == '' || formState.reason == '') {
        message.error('请输入本次拨号原因或总结')
        return
    }
    state.callLoading = true
    let requestParam = {
        url: '/admin/v1/usbphoneCall',
        method: 'post',
        data: {
            'step': 2,
            'zipid': formState.zipid,
            'customer_id': formState.customer_id,
            'phone': formState.phone,
            'remark': formState.remark,
            'reason': formState.reason
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            $store.dispatch('usbphone/AddPhoneModal', {
                phone: '',
                customer_id: null,
                full_name: ''
            })
            message.success('提交成功')
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.callLoading = false
        })
}
const sendmsg = () => {
    if (state.showMsg) {
        state.showMsg = false
        return
    }
    state.msgPreLoading = true
    let requestParam = {
        url: '/admin/v1/usbphone/smsThdata',
        method: 'post',
        data: {
            'customer_id': formState.customer_id,
            'phone': formState.phone
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.thdata = res.data.thdata
            state.templets = res.data.templets
            formState.templet = res.data.defTemp
            state.showMsg = true
            updateMsg()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.msgPreLoading = false
        })
}
const updateMsg = () => {
    formState.msg = formState.templet.replace(/{#(\w+)#}/g, (match, key) => {
        return state.thdata[key] || match;
    });
}
const showOrHideTemplet = () => {
    state.showTemplet = !state.showTemplet
}
const changeTemplet = (templet: any) => {
    formState.templet = templet
    updateMsg()
    state.showTemplet = false
}
const makeSendMsg = () => {
    if (!formState.phone || formState.phone.length != 11) {
        message.error('未找到正确的手机号')
        return
    }
    if (!formState.msg) {
        message.error('请输入短信内容')
        return
    }
    state.msgLoading = true
    let requestParam = {
        url: '/admin/v1/usbphone/usbphoneSms',
        method: 'post',
        data: {
            'phone': formState.phone,
            'msg': formState.msg,
            'templet': formState.templet,
            'customer_id': formState.customer_id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            $store.dispatch('usbphone/SendMsg', { 'phone': formState.phone, 'msg': formState.msg })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.msgLoading = false
        })
}
</script>

<style lang="less" scoped></style>
